import { FEEDBACK_GENERAL_MODULE } from '@malash-office/types';
import { LOGOUT_PATH, NAV_ITEMS } from '@/components/layout/navConfig';

/**
 * Which screen the user is on, as the menu names it — the "מודול" a new request is filed under.
 *
 * Read from `NAV_ITEMS` and not from a list of its own: the menu is the list of screens, and a new
 * screen added there is a module here without anybody remembering this file. The longest matching
 * `to` wins, so `/planning/files` is "ספריית קבצים" and not "פיתוח מוצרים".
 */

const MENU_PAGES = NAV_ITEMS.flatMap(item =>
  item.children
    ? item.children.map(child => ({ to: child.to, label: child.label }))
    : item.to
    ? [{ to: item.to, label: item.label }]
    : []
).filter(page => page.to !== LOGOUT_PATH);

export const moduleForPath = (pathname: string): string => {
  const path = pathname.toLowerCase().replace(/\/$/, '') || '/';
  const match = MENU_PAGES.filter(page =>
    page.to === '/' ? path === '/' : path === page.to || path.startsWith(`${page.to}/`)
  ).sort((a, b) => b.to.length - a.to.length)[0];
  return match?.label ?? FEEDBACK_GENERAL_MODULE;
};

/** Every module a manager may file a request under or filter by: the menu's screens, then "כללי". */
export const feedbackModuleOptions = (extra: string[] = []): string[] => [
  ...new Set([...MENU_PAGES.map(page => page.label), ...extra, FEEDBACK_GENERAL_MODULE])
];
